export default {
  common: {
    ctaStartTrial: 'Get started',
    ctaBookDemo: 'Book a demo',
    noCreditCard: 'Get started in minutes. Plans from $49 a month for 3 drivers.',
    faqTitle: 'Frequently asked questions',
    breadcrumb: {
      home: 'Home',
      resources: 'Resources',
      features: 'Features',
      blog: 'Blog',
      caseStudies: 'Case Studies',
    },
  },
  nav: {
    builtFor: 'Built For',
    features: 'Features',
    resources: 'Resources',
    howItWorks: 'How it works',
    pricing: 'Pricing',
    partners: 'Partners',
    integrations: 'Integrations',
    contact: 'Contact',
    login: 'Log in',
    getStarted: 'Get Started',
    mobileLanguage: 'Language',
    comingSoon: 'Coming soon',
    panels: {
      builtFor: {
        title: 'Industry Solutions',
        subtitle: 'Tailored fleet management solutions for your specific industry needs.',
        viewAll: 'View all industries',
        useCases: 'Industries',
        useCasesSub: 'Grouped by sector — jump in or view the full list.',
        groupFoodHealth: 'Food, health & grocery',
        groupRetailCommerce: 'Retail, e‑commerce & distribution',
        groupLogisticsField: 'Logistics & field operations',
        industryBenefitsTitle: 'Industry Benefits',
        industryBenefitsSub: 'Proven results across sectors',
        quickAccessTitle: 'Quick Access',
        successStory: 'Success Story',
        successStoryTitle: 'How enterprises cut delivery costs by 20–30%',
        successStoryDesc: 'See how leading logistics companies use Geofleet to optimize operations.',
        readCaseStudy: 'Read case study',
        readyToOptimize: 'Ready to optimize your industry operations?',
        getIndustryDemo: 'Get Industry Demo',
      },
      features: {
        title: 'Platform Features',
        subtitle: 'AI-powered tools for delivery, routing, proof of delivery, and fleet operations.',
        viewAll: 'View all features',
        trackingDelivery: 'Tracking & Delivery',
        trackingDeliverySub: 'Customer-facing and driver tools',
        operationsInsights: 'Operations & Insights',
        operationsInsightsSub: 'Automation, finance & analytics',
        aiFirst: 'AI-First',
        everyFeaturePowered: 'Every feature powered by AI',
        automatingDecisions: 'Automating decisions, predicting outcomes, and learning from your data.',
        startFreeTrial: 'Get started',
        getDemo: 'Get a demo',
        readyToAutomate: 'Ready to automate your delivery operations?',
      },
      resources: {
        title: 'Resources',
        subtitle: 'Success stories, guides, and support.',
        viewAll: 'View all resources',
        learning: 'Learning',
        successStories: 'Success Stories',
        support: 'Support',
        latestReport: 'Guide',
        lastMile2026: 'How Geofleet works',
        lastMileDesc: 'Six steps from order to proof of delivery.',
        readReport: 'Read the guide',
        needHelp: 'Need help getting started?',
        contactExperts: 'Contact Our Experts',
      },
    },
    items: {
      builtFor: {
        restaurants: { label: 'Restaurants & QSR', description: 'Deliver faster, improve service' },
        pharmacies: { label: 'Pharmacies', description: 'Reliable prescription delivery' },
        retail: { label: 'Retail', description: 'Simplify retail deliveries' },
        ecommerce: { label: 'E-commerce', description: 'Scale your online store' },
        couriers: { label: 'Couriers & Logistics', description: 'Manage drivers and routes' },
        laundry: { label: 'Laundry & Dry Cleaning', description: 'Pickup and delivery ops' },
        flowers: { label: 'Flowers & Gifts', description: 'Time-sensitive deliveries' },
        water: { label: 'Water Delivery', description: 'Recurring route management' },
        fuel: { label: 'Fuel & Gas Delivery', description: 'On-demand fuel logistics' },
        manufacturing: { label: 'Manufacturing', description: 'Supply chain last-mile' },
        grocery: { label: 'Grocery & Supermarkets', description: 'Slots, density routing, substitutions' },
        'b2b-distribution': { label: 'B2B & Wholesale', description: 'Distribution delivery software' },
        'medical-supplies': { label: 'Medical & Labs', description: 'Specimens, kits, time windows' },
        'field-service': { label: 'Field Service', description: 'Appointments, parts, trucks' },
        'building-supplies': { label: 'Building & Bulky', description: 'Heavy loads, windows, POD' },
        'automotive-parts': { label: 'Automotive Parts', description: 'Same-day & dealer networks' },
        'contract-logistics': { label: '3PL & Contract', description: 'Multi-shipper SLAs & portals' },
      },
      features: {
        brandedTracking: { label: 'Branded Tracking URL', description: 'Custom tracking pages for customers' },
        routePlanner: { label: 'Route Planner', description: 'AI-optimized multi-stop routing' },
        aiAgents: { label: 'AI Agents', description: 'Automate dispatch and operations' },
        proofOfDelivery: { label: 'Proof of Delivery', description: 'Photos, signatures & timestamps' },
        autoAllocation: { label: 'Auto Allocation', description: 'AI agents match orders to drivers' },
        cashManagement: { label: 'Cash Management', description: 'Track cash-on-delivery payments' },
        reportsAnalytics: { label: 'Reports & Analytics', description: 'AI-powered performance insights' },
        driverApp: { label: 'Driver App', description: 'Real-time tracking & tools for drivers' },
      },
      resources: {
        caseStudies: { label: 'Case Studies', description: 'Success stories from customers' },
        blog: { label: 'Blog', description: 'Industry insights and tips' },
        roiCalculator: {
          label: 'ROI calculator',
          description: 'Estimate savings from fewer delays and better fleet utilisation',
        },
        whitepapers: { label: 'Whitepapers', description: 'In-depth research and guides' },
        blogArticles: { label: 'Blog & Articles', description: 'Industry insights and best practices' },
        webinars: { label: 'Webinars & Events', description: 'Live sessions and recordings' },
        customerSuccess: { label: 'Customer Success', description: 'How companies achieve ROI' },
        helpCenter: { label: 'Help Center' },
        apiDocs: { label: 'API Documentation' },
      },
      industryBenefits: {
        fasterDeliveries: { value: '30%', label: 'Faster Deliveries', description: 'Optimized routes reduce delivery times.' },
        costReduction: { value: '20–30%', label: 'Cost Reduction', description: 'Lower fuel and operational costs.' },
      },
      quickAccess: {
        helpCenter: 'Help Center',
        contactSupport: 'Contact Support',
      },
    },
  },
};
